"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowEditPanel = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const use_query_params_1 = require("use-query-params");
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const core_ui_1 = require("@sierralabs/core-ui");
const WorkflowMigrateButton_1 = __importDefault(require("../components/WorkflowMigrateButton"));
const WorkflowStatusActions_1 = __importDefault(require("../components/WorkflowStatusActions"));
const useFindWorkflow_1 = require("../hooks/useFindWorkflow");
const useUpdateWorkflowConfig_1 = require("../hooks/useUpdateWorkflowConfig");
const useWorkflowStatusLabel_1 = require("../hooks/useWorkflowStatusLabel");
const WorkflowBuilderContext_1 = require("../WorkflowBuilderContext");
const Workflow_context_1 = require("../Workflow.context");
const WorkflowEditTab_1 = __importDefault(require("./WorkflowEditTab"));
const WorkflowInfoTab_1 = __importDefault(require("./WorkflowInfoTab"));
const StyledPageTemplate = (0, styled_components_1.default)(core_ui_1.PageTemplate) `
  height: 100%;
  .page-template-dashboard {
    padding: 0;
  }
  .padded-content {
    padding: 20px 30px 0 30px;
  }
`;
const StyledTitle = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  .status-container {
    display: flex;
    margin-top: 5px;
    .status-label {
      margin-right: 8px;
    }
  }
`;
const WorkflowEditPanel = props => {
    const { status } = props;
    const [tab, setTab] = (0, use_query_params_1.useQueryParam)('tab', (0, use_query_params_1.withDefault)(use_query_params_1.StringParam, 'info'));
    const [workflow, setWorkflow] = (0, react_1.useState)();
    const [didUpdate, setDidUpdate] = (0, react_1.useState)(false);
    const { load } = (0, Workflow_context_1.useWorkflowContext)();
    const { selectedWorkflow } = (0, WorkflowBuilderContext_1.useWorkflowBuilderContext)();
    const selectedId = (selectedWorkflow === null || selectedWorkflow === void 0 ? void 0 : selectedWorkflow.id) || 0;
    const { workflow: foundWorkflow, isLoading, error, findWorkflow } = (0, useFindWorkflow_1.useFindWorkflow)(selectedId);
    const { data: updatedWorkflow, error: updateError, updateWorkflowConfig } = (0, useUpdateWorkflowConfig_1.useUpdateWorkflowConfig)((foundWorkflow === null || foundWorkflow === void 0 ? void 0 : foundWorkflow.id) || 0);
    const statusLabel = (0, useWorkflowStatusLabel_1.useWorkflowStatusLabel)(workflow === null || workflow === void 0 ? void 0 : workflow.status);
    const hasWorkflow = workflow && workflow.id === selectedId;
    const tabProps = {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        workflow: workflow,
        onChange: (updated) => {
            setWorkflow(workflow => workflow && Object.assign(Object.assign({}, workflow), updated));
            setDidUpdate(true);
        }
    };
    // unset workflow on change selected
    (0, react_1.useEffect)(() => {
        setWorkflow(undefined);
    }, [selectedId]);
    (0, react_1.useEffect)(() => {
        selectedId && findWorkflow();
    }, [selectedId, findWorkflow]);
    (0, react_1.useEffect)(() => {
        setWorkflow(foundWorkflow);
    }, [foundWorkflow]);
    (0, react_1.useEffect)(() => {
        if (updatedWorkflow) {
            tabProps.onChange(updatedWorkflow);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatedWorkflow]);
    return (react_1.default.createElement(core_ui_1.Panel, { className: 'workflow-edit-panel' },
        react_1.default.createElement(StyledPageTemplate, null,
            react_1.default.createElement(core_ui_1.PageTemplateHeader, null,
                isLoading && react_1.default.createElement(core_1.CircularProgress, { size: 20 }),
                react_1.default.createElement(StyledTitle, null,
                    react_1.default.createElement("h2", null, workflow === null || workflow === void 0 ? void 0 : workflow.name),
                    workflow && (react_1.default.createElement("div", { className: 'status-container' },
                        workflow.version > 1 && (react_1.default.createElement(core_ui_1.StatusLabel, { className: 'published', status: `Published v${workflow.version - 1}` })),
                        workflow.status !== 'published' && (react_1.default.createElement(core_ui_1.StatusLabel, { className: 'draft', status: `${statusLabel} v${workflow.version}` })),
                        status))),
                react_1.default.createElement(core_ui_1.PageTemplateHeaderActions, { flex: true }, workflow && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(WorkflowMigrateButton_1.default, { workflow: workflow, onImport: updateWorkflowConfig }),
                    react_1.default.createElement(WorkflowStatusActions_1.default, Object.assign({}, tabProps, { onChange: workflow => {
                            // reload updated workflow in context
                            load({
                                workflowId: workflow.id,
                                taskTypeId: workflow.taskTypeId
                            });
                            tabProps.onChange(workflow);
                        } })))))),
            react_1.default.createElement(core_ui_1.PageTemplateNav, null,
                react_1.default.createElement(core_1.Tabs, { value: tab, indicatorColor: 'primary', onChange: (_, value) => setTab(value) },
                    react_1.default.createElement(core_1.Tab, { value: 'info', label: 'Info' }),
                    react_1.default.createElement(core_1.Tab, { value: 'edit', label: 'Edit' }))),
            react_1.default.createElement(core_ui_1.PageTemplateDashboard, null,
                workflow && hasWorkflow && (react_1.default.createElement(react_1.Fragment, { key: workflow.id }, tab !== 'edit' ? (react_1.default.createElement("div", { className: 'padded-content' },
                    react_1.default.createElement(WorkflowInfoTab_1.default, Object.assign({}, tabProps)))) : (react_1.default.createElement(WorkflowEditTab_1.default, Object.assign({}, tabProps))))),
                !workflow && !isLoading && (react_1.default.createElement(react_1.default.Fragment, null, error ? (react_1.default.createElement(core_ui_1.ErrorView, { title: 'Workflow not Found', description: `Unable to load workflow. ${error.message}`, icon: react_1.default.createElement(icons_1.Warning, { color: 'disabled', className: 'icon' }) })) : !selectedWorkflow ? (react_1.default.createElement(core_ui_1.ErrorView, { title: 'No Workflow Selected', description: 'Select a Workflow to start editing.', icon: react_1.default.createElement(icons_1.Timeline, { color: 'disabled', className: 'icon' }) })) : null)),
                !hasWorkflow && isLoading && (react_1.default.createElement(core_ui_1.StyledCenterView, null,
                    react_1.default.createElement("div", { className: 'content' },
                        react_1.default.createElement(core_1.CircularProgress, { size: 64, color: 'primary' })))))),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'error', open: !!updateError }, (updateError === null || updateError === void 0 ? void 0 : updateError.message) || 'An error occurred.'),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'success', open: didUpdate, onClose: () => setDidUpdate(false) }, "Workflow Saved")));
};
exports.WorkflowEditPanel = WorkflowEditPanel;
exports.default = exports.WorkflowEditPanel;
//# sourceMappingURL=WorkflowEditPanel.js.map